import {
  DeliveryNoteParams,
  HandlingUnitIdView,
  LoadIdView,
  SpecialFreightIdView,
  TransportOrderIdView,
  WaybillIdView,
  ShipmentIdView,
} from '../../store';

export function isWaybillIdView(idView: ShipmentIdView): idView is WaybillIdView {
  return (idView as WaybillIdView).carrierTO !== undefined;
}

export function isLoadIdView(idView: ShipmentIdView): idView is LoadIdView {
  return (idView as LoadIdView).loadNumber !== undefined;
}

export function isTransportOrderIdView(idView: ShipmentIdView): idView is TransportOrderIdView {
  return (idView as TransportOrderIdView).transportOrderNumber !== undefined;
}

export function isSpecialFreightIdView(idView: ShipmentIdView): idView is SpecialFreightIdView {
  return (idView as SpecialFreightIdView).reference !== undefined;
}

export function isDeliveryNoteParams(idView: ShipmentIdView): idView is DeliveryNoteParams {
  return (idView as DeliveryNoteParams).deliveryNoteNumber !== undefined;
}

export function isHandlingUnitIdView(idView: ShipmentIdView): idView is HandlingUnitIdView {
  return (idView as HandlingUnitIdView).huId !== undefined;
}
